import mock from "./MockConfig";

mock.onAny().passThrough();
